import React, { useState, useEffect, useCallback } from 'react';
import { WSREST_TABATA } from '../../config';
import Card from '../../components/card/Card';
import { getMerlinoT } from '../../services/merlinoService';

function CardInfoIndirizzo({ idordine }) {
    const [shippingDetails, setShippingDetails] = useState(null);

    const fetchShippingDetails = useCallback(async () => {
        const url = `${WSREST_TABATA}ordertabb2c/shippingAddress/${idordine}`;
        const token = getMerlinoT();

        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });

            if (response.ok) {
                const data = await response.json();
                setShippingDetails(data.data);
            } else {
                console.error("Errore nella risposta della spedizione:", response.status);
            }
        } catch (error) {
            console.error("Errore durante la fetch della spedizione:", error);
        }
    }, [idordine]);

    useEffect(() => {
        fetchShippingDetails();
    }, [fetchShippingDetails]);

    const titolo = shippingDetails
    ? `Cliente ${shippingDetails.nome || ''} ${shippingDetails.cognome || ''}<br/><small class='text-muted'>${(shippingDetails.cf || '').toUpperCase()}</small>`
    : 'Cliente';

    return (
        <Card titoloCard={<span dangerouslySetInnerHTML={{ __html: titolo }} />}>
            {shippingDetails && (
                <>
                    <div className="d-sm-flex flex-sm-wrap">
                        <div className="fw-semibold">Indirizzo:</div>
                        <div className="ms-sm-auto mt-1 mt-sm-0">
                            {shippingDetails.indirizzo}, {shippingDetails.cap} - {shippingDetails.localita}
                        </div>
                    </div>
                    <div className="d-sm-flex flex-sm-wrap">
                        <div className="fw-semibold">Telefono:</div>
                        <div className="ms-sm-auto mt-1 mt-sm-0">
                            <a href={`tel:${shippingDetails.telefono}`}>{shippingDetails.telefono}</a>
                        </div>
                    </div>
                    <div className="d-sm-flex flex-sm-wrap">
                        <div className="fw-semibold">Email:</div>
                        <div className="ms-sm-auto mt-1 mt-sm-0 mb-2">
                            <a href={`mailto:${shippingDetails.email}`}>{shippingDetails.email}</a>
                        </div>
                    </div>
                </>
            )}
        </Card>
    );
}

export default CardInfoIndirizzo;
